import * as React from 'react';

import { useRouter } from 'next/router';

import { HeaderProps } from 'src/services/responseTypes/celebsResponse';
import {
  handleRedirectBack,
  handleRedirectToFilmography
} from 'src/utils/celebsUtils/celebsUtils';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';
import { useState } from 'react';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';

import * as styledComponents from './celebStyle';
import { CELEBRITY } from '../../../utils/constants/CelebsConstants';

const Banner: React.FC<HeaderProps> = ({ celebData, renderTitle }) => {
  const { castTypes } = celebData || {};
  const router = useRouter();
  const currentPath = router?.asPath || '';

  const bannerImage = getImageURL({
    deviceWidth: getDeviceWidth() || 0,
    tagName: TAG_NAME.BANNER,
    item: {
      id: celebData.id,
      title: celebData.name,
      image: celebData.image
    }
  });

  const [isImgSrcFailed, setImgSrcFailed] = useState(false);

  const setFallbackImage: React.ReactEventHandler<HTMLImageElement> = (
    event
  ) => {
    const imgElement = event.currentTarget;
    imgElement.onerror = null;
    if (!isImgSrcFailed) {
      setImgSrcFailed(true);
      imgElement.src = '/webapp-assets/images/celebrity-03.png';
    }
  };

  return (
    <>
      <styledComponents.Container>
        <styledComponents.profileImageCircle>
          <styledComponents.profileImage
            alt={celebData?.name || 'content-banner'}
            src={bannerImage}
            onError={setFallbackImage}
            fetchPriority="high"
            data-testid="showDetailMetaImage"></styledComponents.profileImage>
        </styledComponents.profileImageCircle>
        <styledComponents.TitleContainer>
          {renderTitle && renderTitle()}
          <styledComponents.CelebCast>
            {castTypes &&
              castTypes?.map((item: string, index: number) => {
                return (
                  <styledComponents.Cast key={index}>
                    <styledComponents.castTypeContainer>
                      {item}
                    </styledComponents.castTypeContainer>
                  </styledComponents.Cast>
                );
              })}
          </styledComponents.CelebCast>
          {!currentPath?.includes('filmography') ? (
            <styledComponents.Filmography
              onClick={() => handleRedirectToFilmography(currentPath)}>
              {CELEBRITY.VIEW_FILMOGRAPHY}
            </styledComponents.Filmography>
          ) : (
            <styledComponents.Filmography
              onClick={() => handleRedirectBack(currentPath)}>
              {CELEBRITY.VIEW_PROFILE}
            </styledComponents.Filmography>
          )}
        </styledComponents.TitleContainer>
      </styledComponents.Container>
    </>
  );
};

export default Banner;
